import { useEffect, useState } from 'react'

/**
 * Subscribe to a media query. The exchange renders a genuinely different
 * layout on a phone and on a desktop — a chart with a side panel is not a
 * narrow column with tabs — so the breakpoint has to be readable from
 * JavaScript, not only from CSS.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia?.(query).matches ?? false)

  useEffect(() => {
    const mq = window.matchMedia?.(query)
    if (!mq) return
    setMatches(mq.matches)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])

  return matches
}
